// extracted by mini-css-extract-plugin
export default {"background":"_3HuEt","overlay":"_1DXaV","skeleton":"_2kdIw","star":"_2MKQ9","roundStar":"_1gZ4Q","redStar":"_1Te-R","redRoundStar":"_3nzt9"};